document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("mr-point-product")) {
    class MrPointProduct extends HTMLElement {
      constructor() {
        super();

        this.productHandle = this.dataset.productHandle;
        this.blockType = this.dataset.blockType;
        this.variantId = this.dataset.variantId;
        this.taxesIncluded =
          this.dataset.taxesIncluded === "true" ? true : false;
        this.taxRate = this.dataset.taxRate
          ? parseFloat(this.dataset.taxRate)
          : null;
        this.pointRate = this.dataset.pointRate
          ? parseFloat(this.dataset.pointRate)
          : null;

        // Show award point
        if (this.blockType === "award-point") {
          this.initAwardPoint();
        }

        // Set variant change event
        document.addEventListener("mrpoint:update-award-point", (e) => {
          const variantId = e.detail.variantId;
          if (variantId && this.variantPoint) {
            this.setAwardPoint(variantId);
          }
        });
      }

      async initAwardPoint() {
        const data = await this.getProductData();
        if (Object.keys(data).length === 0) return;

        const variants = data.product.variants;
        this.variantPoint = this.getVariantPoint(variants);
        this.setAwardPoint();
      }

      async getProductData() {
        let data = {};

        try {
          const response = await fetch(`/products/${this.productHandle}.json`, {
            method: "GET",
          });
          if (response.status !== 200) {
            throw new Error("Failed to get product data");
          }
          data = await response.json();
        } catch (err) {
          console.error(err);
        }

        return data;
      }

      getVariantPoint(variants) {
        const data = {};
        variants.forEach((variant) => {
          let price = Number(variant.price);
          if (this.taxesIncluded) {
            price = Math.round(price / (1 + this.taxRate));
          }
          const point = Math.floor(price * this.pointRate);
          data[variant.id] = point;
        });
        return data;
      }

      setAwardPoint(variantId = null) {
        this.elAwardPointValue =
          this.elAwardPointValue || this.querySelector(".js-award-point-value");
        const targetId = variantId ? variantId : this.variantId;
        const point = this.variantPoint[targetId];
        this.elAwardPointValue.textContent = (point ?? 0).toLocaleString();
      }
    }

    customElements.define("mr-point-product", MrPointProduct);
  }
});
